import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from './translation/locales/fr.json';
import uk from './translation/locales/uk.json';

export const resources = {
    fr, uk,
};
export const defaultNS = 'common';

i18n.use(initReactI18next)
    .init({
        lng: 'fr',
        ns: ['fr'],
        resources,
        defaultNS,
        fallbackLng: 'fr',
        interpolation: {
            escapeValue: false,
        },
    });
